import { render, staticRenderFns } from "./BpTotalEquityNumberDisplayer.vue?vue&type=template&id=630dd4a9"
import script from "./BpTotalEquityNumberDisplayer.vue?vue&type=script&lang=ts"
export * from "./BpTotalEquityNumberDisplayer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports